/** Doc chrome: format bars, menus, mention chips, onboarding cards, save errors. */
export default {
  smallerText: "Smaller text",
  largerText: "Larger text",
  checklist: "Checklist",
  dictate: "Dictate",
  stopDictation: "Stop dictation",
  dictationUnavailable: "Dictation isn't available here",
  openFrameNamed: "Open {label}",
  openFrame: "Open frame",
  founderPhotoAlt: "Founder photo",
  imageUnsupportedTitle: "Unsupported image format",
  imageUnsupportedBody: "Use PNG, JPEG, WebP, or GIF.",
  imageUploadFailedTitle: "Upload failed",
  imageUploadFailedBody: "Could not upload the image.",
  saveDocEditsFailedTitle: "Couldn’t save Doc edits",
  saveSizeFailedTitle: "Couldn’t save note size",
  saveSizeFailedBody: "The size change was reverted. Please try again.",

  // Doc: selection pill, block handle menu, slash menu
  docAskDenker: "Ask Denker",
  docBold: "Bold",
  docItalic: "Italic",
  docUnderline: "Underline",
  docStrikethrough: "Strikethrough",
  docCode: "Code",
  docLink: "Link",
  docLinkPlaceholder: "Paste a link",
  docLinkAddress: "Link address",
  docApplyLink: "Apply link",
  docTurnInto: "Turn into",
  docColors: "Colors",
  docSlashFrames: "Frames",
  docSlashChartSubtext: "Copy of a chart frame",
  docPage: "Page",
  docSlashPageSubtext: "Copy of a page frame",
  docPageTooLarge: "This page is too large to copy into a Doc.",

  // Doc: an agent's update replaced unsaved edits
  docConflictTitle: "An agent updated this Doc.",
  docConflictBody: "Your last edits were not saved.",
  docConflictRestore: "Restore my edits",
} as const;
